export const COLLABORATION_PROTOCOL_VERSION = 7;
export const COLLABORATION_REVIEW_SCHEMA_VERSION = 1;
export const COLLABORATION_REVIEW_CAPABILITY = 'shared-review-v1';
export const COLLABORATION_REVIEW_CAPABILITY_VERSION = 2;
export const COLLABORATION_REVIEW_TRANSACTION_META_KEY = 'elasticnoteReviewMutation';
export const COLLABORATION_REVIEW_UNDO_IDS_META_KEY = 'elasticnoteReviewChangeIds';
export const COLLABORATION_REVIEW_UNDO_SNAPSHOT_META_KEY = 'elasticnoteReviewUndoSnapshot';

export type CollaborationReviewMutationMeta = {
  source: 'typing' | 'toolbar' | 'ai' | 'citation' | 'paper-memory' | 'tikz' | 'terminal' | 'research' | 'system';
  semanticKind?: string;
  operationId?: string;
};

export type CollaborationSessionCapabilities = {
  protocolVersion: number;
  reviewSchemaVersion: number;
  capabilities: readonly string[];
};
